export enum BetResult {
  WIN = "WIN",
  LOSE = "LOSE",
  VOID = "VOID",
}
